module.exports = __webpack_public_path__ + "assets/img/IMG042.a15441f0.png";